export default __webpack_public_path__ + "static/media/psETH.de646cea.svg";